module.exports = __webpack_public_path__ + "img/myTaskJifen.c599ccfd.png";